import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Public Route - for login/signup pages
 * Waits for the startup auth check before rendering, so authenticated users
 * are redirected to /dashboard without seeing a flash of the login form.
 */
export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated } = useAuth();

  // The startup refresh check (isLoading) is handled by AuthGate in App.tsx,
  // so this only renders once auth state is settled — no flash of the login form.
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
